import { getAdminBuildInfo } from "./buildInfo";

const CHUNK_LOAD_RELOAD_SESSION_KEY = "hc-admin-vite-preload-reload";

const getReloadGuardKey = (): string => {
  const route =
    typeof window !== "undefined"
      ? `${window.location.pathname}${window.location.search}`
      : "unknown-route";
  const { buildSha, buildVersion } = getAdminBuildInfo();
  return `${route}::${buildSha ?? buildVersion}`;
};

/**
 * Returns whether the admin app should attempt a one-time hard reload after a
 * chunk or preload failure.
 *
 * @remarks
 * The session guard is scoped to the current route and build identifier so a
 * fresh deploy can recover once without trapping the user in a same-session
 * reload loop on a persistently broken asset.
 */
export const shouldAutoReloadChunkFailureOnce = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const key = getReloadGuardKey();
    const previousKey = window.sessionStorage.getItem(
      CHUNK_LOAD_RELOAD_SESSION_KEY,
    );
    if (previousKey === key) {
      return false;
    }

    window.sessionStorage.setItem(CHUNK_LOAD_RELOAD_SESSION_KEY, key);
    return true;
  } catch {
    return true;
  }
};
